"use client";

import React from "react";
import { useErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

const Fallback = ({ error, resetErrorBoundary }) => {
  const { resetBoundary } = useErrorBoundary();
  const { t } = useTranslation();
  return (
    <div role="alert">
      <p>{t("something_went_wrong")}</p>
      <button class="btn desktop-btn" onClick={resetBoundary}>
        {t("try_again")}
      </button>
    </div>
  );
};

export default Fallback;
